<template>
  <div id="publishing-journal-website-basic-information">
    <div v-if="isJournal" class="ipub-h1 mar-b-30">
      {{ isEdit ? 'Edit Journal' : 'Add New Journal' }}
    </div>
    <ipub-form
      ref="journal-basic-information-form"
      :model="params"
      :rules="rules"
    >
      <div class="flex">
        <div style="width: 230px">
          <ipub-form-item label="" prop="logo">
            <div slot="label" class="ipub-p2 fw-bd mar-b-10">
              Journal Logo
              <ipub-tooltip placement="right">
                <div slot="title">
                  <div class="font-color ipub-p4">
                    Suggested Size: 230 * 230px; Only support .png; File size
                    need to be less than 500KB.
                  </div>
                </div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
            </div>
            <ipub-upload-cropper
              :canHeight="230"
              :canWidth="230"
              :imgUrl="`${params.logo ? domain + '/' + params.logo : ''}`"
              :scales="2"
              :size="500"
              clearable
              @change="
                (e) => {
                  handleUpload('logo', e)
                }
              "
              @delete="
                () => {
                  ;(params.logo = ''), (params.logoName = '')
                }
              "
            />
          </ipub-form-item>
        </div>
        <div class="mar-l-20" style="width: calc(100% - 230px)">
          <div>
            <ipub-form-item label="Journal’s Full Name" prop="fullName">
              <ipub-input
                v-model.trim="params.fullName"
                placeholder="Enter Journal’s full name"
              />
            </ipub-form-item>
          </div>
          <div>
            <ipub-row :gutter="20">
              <ipub-col :span="6">
                <ipub-form-item label="Journal’s Abbreviation" prop="name">
                  <ipub-input
                    v-model.trim="params.name"
                    :disabled="true"
                    placeholder="Enter journal’s abbreviation"
                  />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="6">
                <ipub-form-item
                  label="Journal’s Abbreviation (Database)"
                  prop="nameDatabase"
                >
                  <ipub-input
                    v-model.trim="params.nameDatabase"
                    placeholder="Enter journal’s abbreviation (Database)"
                  />
                </ipub-form-item>
              </ipub-col>
            </ipub-row>
          </div>
          <div>
            <ipub-row :gutter="20">
              <ipub-col :span="6">
                <ipub-form-item label="Contact Email" prop="contactEmail">
                  <ipub-input
                    v-model.trim="params.contactEmail"
                    placeholder="Enter official contact email"
                  />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="6">
                <ipub-form-item label="Level" prop="contactEmail">
                  <ipub-select
                    v-model="params.details.level"
                    placeholder="Level"
                  >
                    <ipub-select-option
                      v-for="(item, key) in level"
                      :key="key"
                      :value="key"
                    >
                      {{ item }}
                    </ipub-select-option>
                  </ipub-select>
                </ipub-form-item>
              </ipub-col>
            </ipub-row>
          </div>
        </div>
      </div>
      <div class="flex">
        <div style="width: 230px">
          <ipub-form-item label="Journal Cover" prop="cover">
            <div slot="label" class="ipub-p2 fw-bd mar-b-10">
              Journal Cover
              <font class="key-color">*</font>
              <ipub-tooltip class="mar-l-10" placement="right">
                <div slot="title">
                  <div class="font-color ipub-p4">
                    Suggested Size: 480 * 680px; Only support .png; File size
                    need to be less than 500KB.
                  </div>
                </div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
            </div>
            <ipub-upload-cropper
              :canHeight="340"
              :canWidth="240"
              :imgUrl="`${params.cover ? domain + '/' + params.cover : ''}`"
              :scales="1"
              :size="500"
              clearable
              @change="
                (e) => {
                  handleUpload('cover', e)
                }
              "
            />
          </ipub-form-item>
        </div>
        <div class="mar-l-20" style="width: calc(100% - 230px)">
          <div>
            <ipub-form-item
              label="Introduction (Maxmium words: 100)"
              prop="info"
            >
              <ipub-editor
                v-model="params.info"
                :height="340"
                placeholder="Enter introduction of the journal here within 100 words limited"
              />
            </ipub-form-item>
          </div>
        </div>
      </div>
      <div>
        <ipub-form-item
          label="Journal Search Background"
          prop="searchBackground"
        >
          <div slot="label" class="ipub-p2 fw-bd mar-b-10">
            Journal Search Background
            <ipub-tooltip placement="right">
              <div slot="title">
                <div class="font-color ipub-p4">
                  Suggested Size: 1920 * 230px Only support .png; File size need
                  to be less than 500KB.
                </div>
              </div>
              <ipub-icon type="iconInfo" />
            </ipub-tooltip>
          </div>
          <div
            :style="{
              height: '150px',
              width: '100%',
              minWidth: '700px',
              overflow: 'hidden',
              fontSize: '14px',
            }"
            class="upload-content"
          >
            <ipub-upload-cropper
              :canHeight="150"
              :canWidth="1440"
              :imgUrl="`${
                params.searchBackground
                  ? domain + '/' + params.searchBackground
                  : ''
              }`"
              :scales="0.5"
              :size="500"
              clearable
              @change="
                (e) => {
                  handleUpload('searchBackground', e)
                }
              "
              @delete="
                () => {
                  ;(params.searchBackground = ''),
                    (params.searchBackgroundName = '')
                }
              "
            />
          </div>
        </ipub-form-item>
      </div>
      <div>
        <ipub-form-item label="Better Service" prop="openAccess">
          <ipub-editor
            v-model="params.openAccess"
            :height="200"
            placeholder="Enter the related content details…"
          />
        </ipub-form-item>
      </div>
      <div>
        <ipub-form-item label="High Visibility" prop="highVisibility">
          <ipub-editor
            v-model="params.highVisibility"
            :height="200"
            placeholder="Enter the related content details…"
          />
        </ipub-form-item>
      </div>
      <div>
        <ipub-form-item label="Journal Rank" prop="top">
          <ipub-editor
            v-model="params.top"
            :height="200"
            placeholder="Enter the related content details…"
          />
        </ipub-form-item>
      </div>
      <div>
        <ipub-form-item label="Long Tradition" prop="rapidPublication">
          <ipub-editor
            v-model="params.rapidPublication"
            :height="200"
            placeholder="Enter the related content details…"
          />
        </ipub-form-item>
      </div>
      <div>
        <ipub-form-item label="Rapid Publication" prop="recognition">
          <ipub-editor
            v-model="params.recognition"
            :height="200"
            placeholder="Enter the related content details…"
          />
        </ipub-form-item>
      </div>
      <ipub-row :gutter="20">
        <ipub-col :span="6">
          <ipub-form-item label="Author Guideline" prop="authorGuide">
            <ipub-input
              v-model.trim="params.authorGuide"
              placeholder="Enter the URL for Author Guideline"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6">
          <ipub-form-item label="Open Access Permission" prop="openAccessLink">
            <ipub-input
              v-model.trim="params.openAccessLink"
              placeholder="Enter the URL for Open Access Permission"
            />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item prop="publishingAgreement">
            <div slot="label" class="mar-b-10 ipub-p2 fw-bd relative">
              Publishing Policy<font class="key-color">*</font>
              <ipub-tooltip class="mar-l-10" placement="right">
                <div slot="title">
                  Supported file types: pdf;
                  <div class="font-color ipub-p4">Suggested Size: 20MS</div>
                </div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
              <template>
                <ipub-tooltip class="mar-l-10 ipub-c-p" placement="bottomLeft">
                  <div slot="title">Copy File Address</div>
                  <ipub-icon
                    type="iconduplicate"
                    @click="handleCopyAddress(params.publishingAgreement)"
                  />
                </ipub-tooltip>
              </template>
            </div>
            <ipub-upload-input
              :domain="domain"
              :file="params"
              _name="publishingAgreementName"
              _path="publishingAgreement"
              class="mar-b-20"
              @change="
                (e) => {
                  handleUpload('publishingAgreement', e)
                }
              "
              @delete="delFile('publishingAgreement')"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="wordTemplate">
            <div slot="label" class="mar-b-10 ipub-p2 fw-bd relative">
              Word Template<font class="key-color">*</font>
              <ipub-tooltip class="mar-l-10" placement="right">
                <div slot="title">
                  Supported file types: pdf; doc; docx; txt; png; jpg; jpeg;
                  tif; tiff; zip;
                  <div class="font-color ipub-p4">Suggested Size: 20MS</div>
                </div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
              <template>
                <ipub-tooltip class="mar-l-10 ipub-c-p" placement="bottomLeft">
                  <div slot="title">Copy File Address</div>
                  <ipub-icon
                    type="iconduplicate"
                    @click="handleCopyAddress(params.wordTemplate)"
                  />
                </ipub-tooltip>
              </template>
            </div>
            <ipub-upload-input
              :domain="domain"
              :file="params"
              _name="wordTemplateName"
              _path="wordTemplate"
              class="mar-b-20"
              @change="
                (e) => {
                  handleUpload('wordTemplate', e)
                }
              "
              @delete="delFile('wordTemplate')"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="latexTemplate">
            <div slot="label" class="mar-b-10 ipub-p2 fw-bd relative">
              Latex Template<font class="key-color">*</font>
              <ipub-tooltip class="mar-l-10" placement="right">
                <div slot="title">
                  Supported file types: pdf; doc; docx; txt; png; jpg; jpeg;
                  tif; tiff; zip;
                  <div class="font-color ipub-p4">Suggested Size: 20MS</div>
                </div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
              <template>
                <ipub-tooltip class="mar-l-10 ipub-c-p" placement="bottomLeft">
                  <div slot="title">Copy File Address</div>
                  <ipub-icon
                    type="iconduplicate"
                    @click="handleCopyAddress(params.latexTemplate)"
                  />
                </ipub-tooltip>
              </template>
            </div>
            <ipub-upload-input
              :domain="domain"
              :file="params"
              _name="latexTemplateName"
              _path="latexTemplate"
              class="mar-b-20"
              @change="
                (e) => {
                  handleUpload('latexTemplate', e)
                }
              "
              @delete="delFile('latexTemplate')"
            />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="6">
          <ipub-form-item label="Submit URL" prop="submitLink">
            <ipub-input
              v-model.trim="params.submitLink"
              placeholder="Enter the URL for Submission"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6">
          <ipub-form-item label="Review URL" prop="reviewLink">
            <ipub-input
              v-model.trim="params.reviewLink"
              placeholder="Please enter the URL for Review"
            />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item label="Impact Factor" prop="impactFactor">
            <ipub-input
              v-model.trim="params.impactFactor"
              number
              placeholder="Enter Impact Factor"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item label="5 Years Impact Factor" prop="fiveImpactFactor">
            <ipub-input
              v-model.trim="params.fiveImpactFactor"
              number
              placeholder="Enter 5 Years Impact Factor"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item label="CiteScore" prop="citationScore">
            <ipub-input
              v-model.trim="params.citationScore"
              number
              placeholder="Enter Citescore"
            />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item label="Impact Factor URL" prop="impactFactorUrl">
            <div slot="label" class="mar-b-10 ipub-p2 fw-bd relative">
              Impact Factor URL
              <ipub-tooltip placement="right">
                <div slot="title">
                  Like http://www.xxx.com or https://www.xxx.org
                </div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
            </div>
            <ipub-input
              v-model="params.impactFactorUrl"
              placeholder="Enter the URL for Impact Factor"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item
            label="5 Years Impact Factor URL"
            prop="fiveImpactFactorUrl"
          >
            <div slot="label" class="mar-b-10 ipub-p2 fw-bd relative">
              5 Years Impact Factor URL
              <ipub-tooltip placement="right">
                <div slot="title">
                  Like http://www.xxx.com or https://www.xxx.org
                </div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
            </div>
            <ipub-input
              v-model="params.fiveImpactFactorUrl"
              placeholder="Enter the URL for Impact Factor"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item label="CiteScore URL" prop="citationScoreUrl">
            <div slot="label" class="mar-b-10 ipub-p2 fw-bd relative">
              CiteScore URL
              <ipub-tooltip placement="right">
                <div slot="title">
                  Like http://www.xxx.com or https://www.xxx.org
                </div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
            </div>
            <ipub-input
              v-model="params.citationScoreUrl"
              placeholder="Enter the URL for Impact Factor"
            />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="6">
          <ipub-form-item
            label="Submission to First Decision period (Days)"
            prop="decisionDay"
          >
            <ipub-input
              v-model.trim="params.decisionDay"
              number
              placeholder="Enter the number of days from submission to first decision"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6">
          <ipub-form-item
            label="Submission to Acceptance period (Days)"
            prop="receiveDay"
          >
            <ipub-input
              v-model.trim="params.receiveDay"
              number
              placeholder="Enter the number of days from submission to accepted"
            />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <div>
        <ipub-form-item :label="LANGUAGE[language].themeColor" prop="mainColor">
          <ipub-radio-group v-model="params.mainColor">
            <ipub-radio
              v-for="(item, index) in colors"
              :key="'Theme Color' + index"
              :value="item"
            >
              <div
                :style="{ background: item }"
                class="show-color-content"
              ></div>
            </ipub-radio>
            <ipub-radio :value="personalColor">
              <div
                :style="{ background: personalColor }"
                class="show-color-content"
              >
                <input v-model="personalColor" type="color" />
              </div>
            </ipub-radio>
            <font class="link-color ipub-p3">{{
              LANGUAGE[language].customsizeColor
            }}</font>
          </ipub-radio-group>
        </ipub-form-item>
      </div>
      <ipub-row :gutter="20">
        <ipub-col :span="6">
          <ipub-form-item label="Establish Time" prop="buildTime">
            <ipub-input
              v-model.trim="params.buildTime"
              number
              placeholder="Enter the establish time of this journal"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6">
          <ipub-form-item label="Publish Period" prop="publicationCycle">
            <ipub-input
              v-model.trim="params.publicationCycle"
              placeholder="Enter the publish period of this journal"
            />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item
            label="Default Review Dealine(Days)"
            prop="reviewDeadline"
          >
            <ipub-input
              v-model.trim="params.reviewDeadline"
              number
              placeholder="Enter number of days for default review deadline"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item
            label="Default Revision Deadline(Days)"
            prop="revisionDeadline"
          >
            <ipub-input
              v-model.trim="params.revisionDeadline"
              number
              placeholder="Enter number of days for default revision deadline"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item
            label="Special Issues Buffer(Days)"
            prop="specialBufferDay"
          >
            <ipub-input
              v-model.trim="params.specialBufferDay"
              number
              placeholder="Enter number of days for special issue buffer"
            />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item label="ISSN" prop="issn">
            <ipub-input
              v-model.trim="params.issn"
              placeholder="Enter Print ISSN"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item label="EISSN" prop="eissn">
            <ipub-input
              v-model.trim="params.eissn"
              placeholder="Enter Electronic ISSN"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item label="CD-ROM" prop="cdRom">
            <ipub-input
              v-model.trim="params.cdRom"
              placeholder="Enter CD-ROM"
            />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <div>
        <ipub-form-item label="Indexed Database" prop="databaseInclusion">
          <ipub-input
            v-model.trim="params.databaseInclusion"
            placeholder="Indexed Database"
          />
          <!-- <ipub-select v-model="params.databaseInclusions"
                       mode="multiple"
                       placeholder="Indexed Database">
            <ipub-select-option v-for="(value, key) in indexedDatabase"
                                :key="key"
                                :value="key">
              {{ value }}
            </ipub-select-option>
          </ipub-select> -->
        </ipub-form-item>
      </div>
      <div>
        <ipub-form-item
          label="Manuscript Submission Information (Suggested words: 100)"
          prop="submitInfo"
        >
          <ipub-editor v-model="params.submitInfo" :height="200" />
        </ipub-form-item>
      </div>
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item label="Twitter" prop="twitter">
            <ipub-input
              v-model.trim="params.details.twitter"
              placeholder="Enter Twitter account"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item label="Facebook" prop="facebook">
            <ipub-input
              v-model.trim="params.details.facebook"
              placeholder="Enter Fecebook account"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item label="Linkedin" prop="linkedin">
            <ipub-input
              v-model.trim="params.details.linkedin"
              placeholder="Enter Linkedin account"
            />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>

      <ipub-form-item label="Keywords" prop="keywords">
        <ipub-input
          v-model="params.keywords"
          placeholder="Keywords can be separated by a semicolon or carriage return"
          tag
        />
      </ipub-form-item>

      <ipub-form-item label="Subscription" prop="subscriptionInfo">
        <ipub-input
          v-model.trim="params.subscriptionInfo"
          placeholder="Enter Subscription"
        />
      </ipub-form-item>

      <ipub-form-item label="Additional Information">
        <ipub-editor v-model="params.details.extraInfo" :height="200" />
      </ipub-form-item>
      <ipub-form-item label="Side Information">
        <ipub-editor v-model="params.details.sideInfo" :height="200" />
      </ipub-form-item>
      <ipub-form-item label="Other Language">
        <ipub-select
          v-model="params.languageId"
          placeholder="Language"
        >
          <ipub-select-option value="Default" >
            Default
          </ipub-select-option>
          <ipub-select-option
            v-for="(item, key) in languages"
            :key="key"
            :value="item.id"
          >
            {{ item.language }}
          </ipub-select-option>
        </ipub-select>
      </ipub-form-item>
    </ipub-form>
    <div class="btns">
      <ipub-button
        v-if="isJournal"
        plain
        style="width: 150px"
        type="primary"
        @click="
          () => {
            $router.back(-1)
          }
        "
        >Cancel
      </ipub-button>
      <!-- <ipub-button plain
                   style="width:150px"
                   @click="preview"
                   type="primary">{{LANGUAGE[language].preview}}</ipub-button> -->
      <ipub-button
        plain
        style="width: 150px"
        type="primary"
        @click="submit(false)"
        >Save as Draft
      </ipub-button>
      <ipub-button style="width: 150px" type="primary" @click="submit(true)"
        >Publish
      </ipub-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'

export default main
</script>
